<template>
  <div>
    <page-table :data-api="this.api.program" :viewable="false" keyField="id">
      <el-table-column prop="id" label="编号" width="80">
      </el-table-column>
      <el-table-column prop="programName" label="节目名称">
      </el-table-column>
      <el-table-column prop="programAddress" label="节目地址">
      </el-table-column>
      <el-table-column prop="playUrl" label="加速地址">
      </el-table-column>
      <el-table-column label="节目图片" width="120">
        <template slot-scope="scope" v-if="scope.row.programImage">
          <img height="50" :src="scope.row.programImage" />
        </template>
      </el-table-column>
      <el-table-column prop="createDate" label="添加时间">
      </el-table-column>
    </page-table>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  created: function () {},
  methods: {}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// List.vue?8a3ad686